import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CartService } from '../../../cart/services/cart.service';
import { CollectionsService } from '../../../collections/service/collections.service';
import { ProductInterface } from '../../interfaces/product.interface';
import i18next from 'i18next';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';

@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
})
export class AddToCartComponent implements OnInit {
  @Input() product!: ProductInterface;
  quantity = 1;
  collectionId: string;
  productId: string;
  price: number | undefined;
  cartPrice: string | undefined;
  subscriptions: Subscription = new Subscription();
  priceActive = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    public collectionsService: CollectionsService,
    private toastr: ToastrService,
    private cartService: CartService,
    private store: Store<{ cart: any }>,
    private nis: NativeIntegrationService
  ) {
    this.collectionId = this.activatedRoute.snapshot.params.id;
    this.productId = this.activatedRoute.snapshot.params.productId;
  }

  ngOnInit(): void {
    // aktueller Preis von Produktdetailseite
    this.price = this.product.price;
    this.updatePrice();
    // Subscriber zum Oeffnen und Schließen des Warenkorbs
    const cartOpenSub = this.cartService.cartOpen$.subscribe();
    this.subscriptions.add(cartOpenSub);
    // Subscriber zum Ein- und Ausblenden des Preises
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscriptions.add(priceActiveSub);
    const inCart = this.cartService.isInCart(this.product.sku);
    // Wenn der Artikel bereits im Warenkorb ist, wird die Menge/Stückzahl neu gesetzt und der Preis berechnet
    if (inCart) {
      console.log(this.product.sku.toString());
      const element = inCart;
      console.log('[ADD TO CART]: Product in cart - update quantity');
      console.log(element);
      if (element) {
        this.quantity = element.quantity;
      }
      this.updatePrice();
    }
  }

  // Zählt Menge hoch
  quantityUp(): void {
    this.nis.hapticFeedbackClick();
    this.quantity += 1;
    if (this.price) {
      this.cartPrice = this.collectionsService.currency.format(
        this.price * this.quantity
      );
    }
  }

  // Zählt Menge runter
  quantityDown(): void {
    this.nis.hapticFeedbackClick();
    if (this.quantity > 1) {
      this.quantity -= 1;
      if (this.price) {
        this.cartPrice = this.collectionsService.currency.format(
          this.price * this.quantity
        );
      }
    }
  }

  // Fügt Artikel dem Warenkorb hinzu
  addToCart(): void {
    this.cartService.addToCart(
      this.product,
      this.collectionId,
      this.quantity,
      () => {
        // Zeigt Erfolgsmeldung
        const toastAddSub = this.toastr
          .info(
            i18next.t('add-to-cart.note-add-1') +
              ' <strong>' +
              i18next.t(this.product.texts.title) +
              ' (' +
              this.quantity +
              'x)</strong> ' +
              i18next.t('add-to-cart.note-add-2') +
              '<br><small>' +
              i18next.t('add-to-cart.note-open-bag') +
              '</small>'
          )
          .onTap.pipe(take(1))
          .subscribe(() => this.openCart());
        this.subscriptions.add(toastAddSub);
      },
      () => {
        const toastUpdateSub = this.toastr
          .info(
            i18next.t('add-to-cart.note-update') +
              '<br><strong>' +
              i18next.t(this.product.texts.title) +
              ' (' +
              this.quantity +
              'x)</strong><br><small>' +
              i18next.t('add-to-cart.note-open-bag') +
              '</small>'
          )
          .onTap.pipe(take(1))
          .subscribe(() => this.openCart());
        this.subscriptions.add(toastUpdateSub);
      }
    );
  }

  // Öffnet Warenkorb Overlay
  openCart(): void {
    this.cartService.cartOpen$.next(true);
    this.nis.hapticFeedbackClick();
  }

  // Berechnet Preis * Menge und berücksichtigt die Währung
  updatePrice(): void {
    if (this.price) {
      this.cartPrice = this.collectionsService.currency.format(
        this.price * this.quantity
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
